app.controller('change_passwordController', function($http, $scope, $stateParams, $location, dataService, DTColumnBuilder, pageConfig, pageHandler, $timeout, $controller) {
    
  //Include custom controller functionality
	$controller('userDefinedChangePasswordController', {$scope: $scope, $stateParams: $stateParams});
  
	//initialise survey specific views
	pageHandler.initViews(pageConfig, $scope);

	//initialise filters
	var filtersLoaded = pageHandler.initFilters(pageConfig, $scope);
	
	if(filtersLoaded)
	{	
		//initialise components
		pageHandler.initComponents(pageConfig, $scope);
	
		//show loading on components
		pageHandler.showLoading(pageConfig, $scope);
	
		//request data for components
		pageHandler.requestDataForComponents(pageConfig, $scope);
		
		//initialize export feature
		pageHandler.initPageExports(pageConfig, $scope);
	}

	$scope.notify_msg = "";
	$scope.notify_msg_class = "";
	$scope.updateParams = {
		old_password : "",
		new_password: "",
		retype_password: ""
	};


	$scope.submit_form_data = function()
	{
		formData = $scope.updateParams;
		//post the form's data
		dataService.getData('change_password/update', formData, 'POST', false, null, false, $scope)
		.then(function(response) 
		{
			//Return the status
			if(typeof(response.success) != undefined && response.success)
			{
				//Reset the field values
				$scope.notify_msg = typeof(response.message) != undefined?response.message:"";
				$scope.notify_msg_class = "alert alert-success in";
				$scope.updateParams = {
					old_password : "",
					new_password: "",
					retype_password: ""
				};

				//Reset the password expiry notification if available
				$('.password-expiry-wanrning').hide();
			}
			else
			{
				$scope.notify_msg = typeof(response.message) != undefined?response.message:"";
				$scope.notify_msg_class = "alert alert-danger in";
			}
		});
	};
	
	$scope.checkForm = function(form)
	{
		//Check if old password is empty
		if($scope.updateParams.old_password == "") 
		{
			$scope.notify_msg = "The current password you have entered is empty!";
			$scope.notify_msg_class = "alert alert-danger in";
			$('form input.current_password').focus();
			return false;
		}

		//Check if new password is empty
		if($scope.updateParams.new_password == "") 
		{
			$scope.notify_msg = "The new password you have entered is empty!";
			$scope.notify_msg_class = "alert alert-danger in";
			$('form input.new_password').focus();
			return false;
		}

		if($scope.updateParams.new_password != "" && $scope.updateParams.new_password == $scope.updateParams.retype_password) 
		{
			if(!checkPassword($scope.updateParams.new_password)) 
			{
				$scope.notify_msg = "The password you have entered is not valid!";
				$scope.notify_msg_class = "alert alert-danger in";
				$('form input.new_password').focus();
				return false;
			}
		} 
		else 
		{
			$scope.notify_msg = "Error: Password mismatch";
			$scope.notify_msg_class = "alert alert-danger in";
			$('form input.new_password').focus();
			return false;
		}

		$scope.notify_msg = "";
		$scope.notify_msg_class = "";

		$scope.submit_form_data();
		return false;
	}
    
	//Evaluate the properties of new password
	$scope.new_password_strength = password_evaluator($scope.updateParams.new_password);
	//to update the evaluation of new password
	$scope.newPasswordChanged = function()
	{
		$scope.new_password_strength = password_evaluator($scope.updateParams.new_password);
	}
});
